import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'
import css from './filter.css'

const checkboxStyle = {
  marginLeft: 0,
  fontSize: '18px',
}

const ItemsList = ({ onChange, items, checkboxes }) => {
  const isChecked = item => items.includes(item)
  const handleOnChange = ({ target: { checked, value } }) =>
    onChange(checked, value)

  return (
    <div className={css.productList}>
      {checkboxes.map(({ value, label }) => (
        <Checkbox
          key={value}
          value={value}
          onChange={handleOnChange}
          checked={isChecked(value)}
          style={checkboxStyle}
        >
          {label}
        </Checkbox>
      ))}
    </div>
  )
}

ItemsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  checkboxes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
}

export default ItemsList



// WEBPACK FOOTER //
// ./src/Dashboard/Filters/ItemsList.js